/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {localStorage} from '../../services';
import {TokenType} from '../LocalStorage/TokenType';

export interface AuthenticationData {
	clientToken: {
		accountName: string;
		nonce: string;
		signature: string;
	};
	redirectURL: string;
	rememberMeToken: {
		accountName: string;
		nonce: string;
		signature: string;
	};
	secondFactorToken: {
		accountName: string;
		nonce: string;
		signature: string;
	};
}

class LoginService {

	login(authenticationData: AuthenticationData): void {
		localStorage.setToken(
			TokenType.CLIENT,
			authenticationData.clientToken.accountName,
			authenticationData.clientToken.nonce,
			authenticationData.clientToken.signature
		);

		if (authenticationData.rememberMeToken)
			localStorage.setToken(
				TokenType.REMEMBER_ME,
				authenticationData.rememberMeToken.accountName,
				authenticationData.rememberMeToken.nonce,
				authenticationData.rememberMeToken.signature
			);

		localStorage.setToken(
			TokenType.SECOND_FACTOR,
			authenticationData.secondFactorToken.accountName,
			authenticationData.secondFactorToken.nonce,
			authenticationData.secondFactorToken.signature
		);

		window.location.href = authenticationData.redirectURL;
	}
}

export default LoginService;
